import { createContext, type ReactNode } from "react";

/** Keeps the shared ready/loading view independent of the router. */
export const LearnSummaryHeaderContext = createContext<((title: ReactNode) => void) | null>(null);
